import { EuiButtonIcon } from "@inscopix/ideas-eui";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

export const QuickActionToggleNotes = () => {
  const flyoutRightContent = useDataTableContext((s) => s.flyoutRightContent);
  const setFlyoutRightContent = useDataTableContext(
    (s) => s.setFlyoutRightContent,
  );

  const showingTableDescription = flyoutRightContent === "tableDescription";

  return (
    <EuiButtonIcon
      size="xs"
      display={showingTableDescription ? "base" : "empty"}
      iconType="documentEdit"
      aria-label="Toggle notes"
      onClick={() =>
        setFlyoutRightContent(
          !showingTableDescription ? "tableDescription" : undefined,
        )
      }
      id={"quickActionToggleNotes"}
    />
  );
};
